// libraries
import qs from 'qs';
// services
import AxiosInstanceCreator from 'services/api';

const seclInstance = new AxiosInstanceCreator().create();

export const seclApi = {
  /**
   * SECL History 조회
   * @param {userId, page, issueDateFrom, issueDateTo} data
   * @returns
   */
  async getSeclHistoryList(data) {
    return await seclInstance.get(`/secl?${qs.stringify(data)}`).then((res) => res.data);
  },

  /**
   * SECL History  조회-벤더용
   * @param {companyId, page, issueDateFrom, issueDateTo} data
   * @returns
   */
  async getSeclHistoryListVendor(data) {
    return await seclInstance.get(`/secl/company?${qs.stringify(data)}`).then((res) => res.data);
  },

  /**
   * SECL List 조회
   * @param {ptwId} id
   * @returns
   */
  async getSeclList(id) {
    return await seclInstance.get(`/secl/${id}`).then((res) => res.data);
  },

  /**
   * SECL SAVE
   * @param {ptwId, approvalUserId, approvalName, order, badgeNo, signatureFileId, comment, permitNumber, companyId, companyName} data
   * @returns
   */
  async createSecl(data) {
    return await seclInstance.post(`/secl`, data).then((res) => res.data);
  }
};
